
//系统目录 / 药品加成率 接口相关的函数
import request from "@/untils/request.js"

/**
 * 
 *  post
 *  
 */

//新建药品加成率
export const docMark = (data) => {
    return request.post("/outpatient/docMark", data )
}

/**
 * 
 * put
 *  
 */

//修改药品加成率
// export const getInventPage = (data) => {
//     return request.get("/outpatient/page", data )
// }

/**
 * 
 * get 
 *  
 */

// 点击批次号显示 => 古
// export const getBatchNumber = (params) => {
//     return request.get("/outpatient/getBatchNumber", { params } )
// }
// 点击西药库批次号显示 => 张林
export const getBatchNumber = (data) => {
    return request.post("/outpatient/dgsDpurcTable/infoDrug", data )
}
// 点击卫材库批次号显示 => 张林
export const getWCBatchNumber = (data) => {
    return request.post("/outpatient/eisaiTable/infoEisai", data )
}
// 点击中药库批次号显示 => 张林
export const getZYBatchNumber = (data) => {
    return request.post("/outpatient/purctcmtable/infoTcmDrug", data )
}
// 点击中药房批次号显示 => 张林
export const getZYFBatchNumber = (data) => {
    return request.post("/outpatient/dugpurctcmtable/infoTcmDrug", data )
}
// 点击西药房批次号显示 => 张林
export const getYFBatchNumber = (data) => {
    return request.post("/outpatient/dugdpurctable/infoDrug", data )
}
// 点击效期调整
export const getExpyDate = (params) => {
    return request.get("/outpatient/getExpyDate", { params } )
}
// 点击中药库效期调整
export const getZYKExpyDate = (params) => {
    return request.get("/outpatient/purctcmtable/getExpyDate", { params } )
}
// 更新有效日期 => 古
// export const updateDate = (params) => {
//     return request.get("/outpatient/updateDate", { params } )
// }
// 更新xyk有效日期 => 张
export const updateDate = (data) => {
    return request.post("/outpatient/dgsDpurcTable/updateDate", data )
}

// 追溯码库存信息-分页查询
export const barcodePageList = (data) => {
    return request.post("/outpatient/barcode/pageList", data)
}

// 查询追溯码变更明细
export const barcodeChgDetail = (params) => {
    return request.get("/outpatient/barcode/chgDetail", { params })
}

// 更新xyf有效日期 => 张
export const updateYFDate = (data) => {
    return request.post("/outpatient/dugdpurctable/updateDate", data )
}
// 更新我卫材有效日期 => 张
export const updateWCDate = (data) => {
    return request.post("/outpatient/eisaiTable/updateDate", data )
}
// 更新zyk有效日期 => 张
export const updateZYDate = (data) => {
    return request.post("/outpatient/purctcmtable/updateDate", data )
}
// 更新zyf有效日期 => 张
export const updateZYFDate = (data) => {
    return request.post("/outpatient/dugpurctcmtable/updateDate", data )
}
// 西药药品明细流向 => 古
// export const chgDetails = (params) => {
//     return request.get("/outpatient/chgDetails/page", { params } )
// }
// 西药药品明细流向 => 张林
export const chgDetails = (data) => {
    return request.post("/outpatient/dgsDpurcTable/chgDetails", data )
}
// 卫材药品明细流向 => 张林
export const chgWCDetails = (data) => {
    return request.post("/outpatient/eisaiTable/chgDetails", data )
}
// 中药药品明细流向 => 张林
export const ZYchgDetails = (data) => {
    return request.post("/outpatient/purctcmtable/chgTcmDetails", data )
}
// 中药房药药品明细流向 => 张林
export const ZYFchgDetails = (data) => {
    return request.post("/outpatient/dugpurctcmtable/chgTcmDetails", data )
}

// 西药库存列表 => 张林
export const getInventPage = (data) => {
    return request.post("/outpatient/dgsDpurcTable/info", data)
}
// 卫材库存列表 => 张林
export const getWCInventPage = (data) => {
    return request.post("/outpatient/eisaiTable/eisaiPageList", data)
}
// 中药库存列表 => 张林
export const getZYInventPage = (data) => {
    return request.post("/outpatient/purctcmtable/tcmInfo", data)
}
// 中药房库存列表 => 张林
export const getZYFInventPage = (data) => {
    return request.post("/outpatient/dugpurctcmtable/pageList", data)
}

/*
 * 
 * DELETE 
 *   
 */   

// 暴露
export default{
	getInventPage,chgDetails,
	
	// 效期设置相关
	getBatchNumber,getExpyDate,updateDate,
	
	// ? 西药房 => zl 
	getYFBatchNumber,
}